import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import TopBar from "./TopBar/TopBar";
import logo from "../../../img/logo.png";
import "./Header.css";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../../firebase.init";
import { signOut } from "firebase/auth";

const Header = () => {
  const [user] = useAuthState(auth);
  const handleLogout = () => signOut(auth);

  return (
    <div>
      <TopBar></TopBar>
      <div className="container-fluid navbar-content">
        <div className="container">
          <>
            <Navbar
              variant="light"
              collapseOnSelect
              expand="lg"
              className="justify-content-between"
            >
              <Navbar.Brand as={Link} to="/">
                <img src={logo} alt="" />
              </Navbar.Brand>
              <>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="navs">
                    <Nav.Link as={Link} to="/">
                      Home
                    </Nav.Link>
                    <Nav.Link as={Link} to="/about">
                      About
                    </Nav.Link>
                    <Nav.Link as={Link} to="/courses">
                      Classes
                    </Nav.Link>
                    <Nav.Link as={Link} to="/blog">
                      Blog
                    </Nav.Link>
                    {user ? (
                      <Nav.Link onClick={handleLogout} as={Link} to="/login">
                        Logout
                      </Nav.Link>
                    ) : (
                      <Nav.Link as={Link} to="/login">
                        Login
                      </Nav.Link>
                    )}
                  </Nav>
                </Navbar.Collapse>
              </>
            </Navbar>
          </>
        </div>
      </div>
    </div>
  );
};

export default Header;
